module.exports = __webpack_public_path__ + "static/media/ImpactStoryLogo2Accenture.2e1d3298.png";